/* eslint-disable sort-keys */
// eslint-disable-next-line no-unused-vars
const widgettypes = [
    "MyActionStatus",
    "ActionButtons",
    "ActionQuicklink",
    "NextAssignedButton",
    "CurrentWorkflowState",
    "NextWorkflowState",
    "LastApprovedBy",
    "DueDate",
    "AuthorDueDate",
    "ApprovalPopout",
    "CurrentTaskHolders",
    "ProgressButton",
    "RegressButton",
    "ForceButton",
    "AssignedToYouBy",
    "EditAssignee",
    "EditDueDate",
    "EditLockContent",
    "WorkflowSettings",
    "ReadOnlyMessage",
    "StageApproveRejectMessage",
    "StageRejectMessage",
    "StageApproveMessage",
];

const executiveConfig =   {
    requiredRoles: [],
    requiredActions: [
        {
            type: "APPROVE",
            status: "PENDING"
        }
    ],
    header: [
        {
            key: "000",
            component: "ApprovalHeaderBorder",
        },
        {
            key: "0",
            component: "StageApproveRejectMessage",
        },
        {
            key: "00",
            component: "NextAssignedButton",
        },
        {
            key: "1",
            component: "MyActionStatus",
        },
        {
            key: "2",
            component: "LastApprovedBy",
        },
        {
            key: "3",
            component: "DueDate",
        },
        {
            key: "4",
            component: "ApprovalPopout",
        },
        {
            key: "5",
            component: "ActionButtons",
        },
    ],
    summary: [
        {
            key: "6",
            component: "ActionQuicklink",
        }
    ],
    details: [
        {
            key: "7",
            component: "CurrentWorkflowState",
        },
        {
            key: "8",
            component: "CurrentTaskHolders",
        }
    ]
};

const authorConfig = {
    requiredRoles: ["document:1234:collaborator"],
    requiredActions: [],
    header: [
        {
            key: "1",
            component: "MyActionStatus",
        },
        {
            key: "2",
            component: "AssignedToYouBy",
        },
        {
            key: "3",
            component: "AuthorDueDate",
        },
        {
            key: "4",
            component: "ProgressButton",
        },
    ],
    summary: [
        {
            key: "6",
            component: "ActionQuicklink",
        }
    ],
    details: [
        {
            key: "7",
            component: "CurrentWorkflowState",
        },
        {
            key: "8",
            component: "CurrentTaskHolders",
        }
    ]
};

const adminConfig = {
    requiredRoles: ["document:1234:administrator"],
    requiredActions: [],
    header: [
        {
            key: "1",
            component: "ForceButton",
        }
    ],
    summary: [
        {
            key: "6",
            component: "ActionQuicklink",
        }
    ],
    details: [
        {
            key: "7",
            component: "CurrentWorkflowState",
        },
        {
            key: "8",
            component: "EditAssignee",
        },
        {
            key: "9",
            component: "EditDueDate",
        },
        {
            key: "10",
            component: "EditLockContent",
        },
    ],
    footer: {
        key: "11",
        component: "WorkflowSettings"
    }
};

const fallbackConfig = {
    requiredRoles: ["document:*:*"],
    requiredActions: [],
    header: [
        {
            key: "1",
            component: "ReadOnlyMessage",
        }
    ],
    summary: [
        {
            key: "6",
            component: "ActionQuicklink",
        }
    ],
    details: [
        {
            key: "7",
            component: "CurrentWorkflowState",
        },
        {
            key: "8",
            component: "CurrentTaskHolders",
        }
    ]
};

const defaultConfig = {
    requiredRoles: ["*:*:*"],
    requiredActions: [],
    header: [],
    summary: [],
    details: [],
};

export const workflowConfigs = [
    executiveConfig,
    authorConfig,
    adminConfig,
    fallbackConfig,
    defaultConfig
];
